function memoize(fn) {
    var cache = Object.create(null);
    return function (arg) {
        if (cache[arg] === undefined)
            cache[arg] = fn(arg);
        return cache[arg];
    };
}
export default memoize;
